import React, { Component } from "react"
import CustomCheckbox from '../../elements/CustomCheckbox/CustomCheckbox'
import { RadioSelect } from '../../elements/RadioSelect/RadioSelect'
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'
import { noYes, noYesOther, yesHesitateNo, one2fiveQuality, one2fiveLevel, one2fiveTEXT } from '../../variables/ComboValues'
import { updateElement } from "../Tree/Utils.js"

// TODO: get data from DB && Update to DB
const  microLegend = {
  "intake_date": "מועד קיום האינטייק",
  "intake_team": "מלווה",
  "intake_q1": "מהם האתגרים המרכזיים שמשפחה מתמודדת אתם (כלכלית/תעסוקתית/חינוך/חברתית וכיו''ב)?",
  "intake_q2": "האם יש למשפחה תמיכה (רגשית/חברתית/כלכלית) כלשהי? משפחה, חברים, שכנים?",
  "intake_q3": "האם מישהו מבני המשפחה מטופל במחלה פיזיולוגית באופן קבוע?",
  "intake_q3_other": "אחר",
  "intake_q4": "האם מישהו מבני המשפחה נזקק לטיפול נפשי בחמש השנים האחרונות או מטופל בתרופות פסיכיאטריות?",
  "intake_q4_other": "אחר",
  "intake_q5": "האם ישנם התמכרויות במשפחה (אלכוהול, סמים, הימורים)?",
  "intake_q5_other": "אחר",
  "intake_q6": "באיזה שירותים אתם משתמשים?",
  "intake_q61": "מתנ''ס",
  "intake_q62": "מעון יום",
  "intake_q63": "מרכז לילד ולמשפחה",
  "intake_q64": "תחנה לבריאות הציבור / טיפת חלב",
  "intake_q65": "ארגוני חסד / גמ''ח",
  "intake_q66": "עזרה של עמותות (ידיד ועוד)",
  "intake_q67": "עזרה בלימודים לילדים (חונך, מרכז למידה ועוד)",
  "intake_q68": "תחנה לבריאות הנפש",
  "intake_q69": "קופת חולים",
  "intake_q610": "פעילות העשרה לילדים בשעות אחה''צ (חוגים, תנועת נוער)",
  "intake_q611": "לשכת הרווחה",
  "intake_q612": "אחר",
  "intake_q7": "באלו נושאים אתם מעוניינים לקבל סיוע?",
  "intake_q71": "בניית פרופיל תעסוקתי אישי - מהם היכולות, המיומנויות והשאיפות שלי בשוק העבודה",
  "intake_q72": "חיזוק כלים לעבודה (כגון, אנגלית, מחשבים)",
  "intake_q73": "הכשרה מקצועית",
  "intake_q74": "לימודים אקדמאים",
  "intake_q75": "כלים למציאת עבודה",
  "intake_q76": "מציאת עבודה או עזרה בהשמה בעבודה",
  "intake_q77": "עזרה בשדרוג העבודה שלי ו/או של בן / בת הזוג שלי",
  "intake_q78": "יעוץ בפתיחת עסק (למשל, במט''י - מרכז לטיפוח יזמות)",
  "intake_q79": "פתיחה מחדש של עסק",
  "intake_q710": "הגדלת התפוקה של עסק קיים",
  "intake_q711": "סיוע במיצוי זכויות",
  "intake_q712": "התנהלות כלכלית נכונה",
  "intake_q713": "העצמה אישית - חיזוק יכולות אישיות",
  "intake_q714": "יחסים בין בני הזוג",
  "intake_q715": "יחסים עם הילדים",
  "intake_q716": "פיתוח וחיזוק קשרים חברתיים",
  "intake_q717": "מענה לצרכים חינוכיים של הילדים",
  "intake_q718": "העשרה של הילדים",
  "intake_q719": "אחר",
  "intake_q7_other": "מיותר?",
  "intake_q801": "מהם החלום/ות שלכם?",
  "intake_q802": "מה לדעתכם יעזור לכם להגשים אותו?",
  "intake_q803": "האם תוכלו לציין דבר קטן או גדול שרציתם לשנות והצלחתם?",
  "intake_q804": "במידה וכן, מה עזר לכם להגיע להצלחה?",
  "intake_q805": "מה הייתה ההתמודדות שלכם בהשגת המטרה הזו? (מה היו הקשיים שעליהם היו צריכים להתגבר?)",
  "intake_q806": "האם אתם יכול לראות את עתיד המשפחה שלך בעוד שנתיים?",
  "intake_q807": "במידה וכן - תארו אותו",
  "intake_q8": "אשה: באיזו מידה את מעוניינת להשתתף בתוכנית לשיפור מצבכם המשפחתי?",
  "intake_q9": "אשה: חששות ו/או הסתייגויות",
  "intake_q10": "גבר: באיזו מידה אתה מעוניין להשתתף בתוכנית לשיפור מצבכם המשפחתי?",
  "intake_q11": "גבר: חששות ו/או הסתייגויות",
  "intake_q12": "מהן הציפיות שלכם מהתכנית?",
  "intake_q13": "חוות דעת בסיום אינטייק",
  "intake_q14": "מידת החומרה של מצב המשפחה",
  "intake_q141": "מבחינה כלכלית",
  "intake_q142": "מבחינת תיאום ושיתוף פעולה בין בני הזוג",
  "intake_q143": "מבחינת מצב תעסוקתי נוכחי של האשה",
  "intake_q144": "מבחינת מצב תעסוקתי נוכחי של הגבר",
  "intake_q145": "מבחינת היקף ו/או חומרת הצרכים של הילדים",
  "intake_q146": "מבחינת תפקוד הורי של האשה",
  "intake_q147": "מבחינת תפקוד הורי של הגבר",
  "intake_q151": "מוטיבציה ומחויבות לשינוי",
  "intake_q152": "כוחות לביצוע השינוי",
  "intake_q153": "פניות לביצוע השינוי",
  "intake_q154": "מבחינת מצב תעסוקתי נוכחי של הגבר",
  "intake_q155": "מבחינת היקף ו/או חומרת הצרכים של הילדים",
  "intake_q156": "מבחינת תפקוד הורי של האשה",
  "intake_q157": "מבחינת תפקוד הורי של הגבר",
  "intake_q16": "החלטת מנהלת",
  "intake_q17": "הסבר החלטת מנהלת",
  "intake_q18": "החלטת משפחה",
  "intake_code": "קוד אינטייק",
  "intake_family_code": "קוד הפנייה"
}

export class IntakeNeedExpectations extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
    }
    
    handleProductTable= (evt) => {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable = (evt) => {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} 
            products={this.state.products} 
          />
      )
    }
  }
   
  class ProductTable extends React.Component {
    constructor(props){
      super(props)
      this.state={
          detailedDisplay: false
      }
      this.toggleDisplay = this.toggleDisplay.bind(this)
    }
    toggleDisplay = (evt) => {
      let tog = !this.state.detailedDisplay
      this.setState({detailedDisplay: tog})
    }
    qData = (products) => {
      
      const product = products
      const cellData=[/*{
        type: "text",
        name: "intake_date",
        value: product.intake_date,
        id: product.id,
        style: {width: "120px"},
        edit: true
      },{
        type: "checkbox",
        name: "intake_team",
        value: product.intake_team,
        id: product.id,
        style: {width: "130px"},
        edit: true
      },*/{
        type: "textarea",
        name: "intake_q1",
        value: product.intake_q1,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_q2",
        value: product.intake_q2,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYesOther, // ["נא לבחור","כן","לא","אחר"],
        name: "intake_q3",
        value: product.intake_q3,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "text",
        name: "intake_q3_other",
        value: product.intake_q3_other,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYesOther,
        name: "intake_q4",
        value: product.intake_q4,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "text",
        name: "intake_q4_other",
        value: product.intake_q4_other,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYesOther,
        name: "intake_q5",
        value: product.intake_q5,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "text",
        name: "intake_q5_other",
        value: product.intake_q5_other,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        newsection: "באיזה שירותים אתם משתמשים?",
        type: "radioSelect",
        options: noYes,
        name: "intake_q61",
        value: product.intake_q61,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q62",
        value: product.intake_q62,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q63",
        value: product.intake_q63,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q64",
        value: product.intake_q64,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q65",
        value: product.intake_q65,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q66",
        value: product.intake_q66,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q67",
        value: product.intake_q67,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q68",
        value: product.intake_q68,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q69",
        value: product.intake_q69,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q610",
        value: product.intake_q610,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q611",
        value: product.intake_q611,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "text",
        //options: noYes,
        name: "intake_q612",
        value: product.intake_q612,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        newsection: "באלו נושאים אתם מעוניינים לקבל סיוע?",
        type: "radioSelect",
        options: noYes,
        name: "intake_q71",
        value: product.intake_q71,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q72",
        value: product.intake_q72,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q73",
        value: product.intake_q73,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q74",
        value: product.intake_q74,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q75",
        value: product.intake_q75,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q76",
        value: product.intake_q76,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q77",
        value: product.intake_q77,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q78",
        value: product.intake_q78,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q79",
        value: product.intake_q79,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q710",
        value: product.intake_q710,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q711",
        value: product.intake_q711,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q712",
        value: product.intake_q712,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q713",
        value: product.intake_q713,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q714",
        value: product.intake_q714,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q715",
        value: product.intake_q715,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q716",
        value: product.intake_q716,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q717",
        value: product.intake_q717,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,
        name: "intake_q718",
        value: product.intake_q718,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "text",
        //options: noYes,
        name: "intake_q719",
        value: product.intake_q719,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        newsection: "שאיפות ומוטיבציה לשינוי",
        type: "textarea",
        name: "intake_q801",
        value: product.intake_q801,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_q802",
        value: product.intake_q802,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: yesHesitateNo, // ["לא","מהססים","כן"],
        name: "intake_q803",
        value: product.intake_q803,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_q804",
        value: product.intake_q804,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_q805",
        value: product.intake_q805,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: yesHesitateNo, // ["לא","מהססים","כן"],
        name: "intake_q806",
        value: product.intake_q806,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_q807",
        value: product.intake_q807,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveTEXT, // ["1-כלל לא","2- במידה מעטה","3- במידה בינונית","4- במידה רבה","5- במידה רבה מאוד"],
        name: "intake_q8",
        value: product.intake_q8,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_q9",
        value: product.intake_q9,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveTEXT, // ["1-כלל לא","2- במידה מעטה","3- במידה בינונית","4- במידה רבה","5- במידה רבה מאוד"],
        name: "intake_q10",
        value: product.intake_q10,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_q11",
        value: product.intake_q11,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_q12",
        value: product.intake_q12,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },/*{
        type: "textarea",
        name: "intake_q13",
        value: product.intake_q13,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },*/{
        newsection: "מידת החומרה של מצב המשפחה",
        type: "radioSelect",
        options:one2fiveQuality, // ["1-חמור מאוד","2- בעייתי","3- בינוני/סביר","4- תקין","5- טוב מאוד"],
        name: "intake_q141",
        value: product.intake_q141,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveQuality, // ["1-חמור מאוד","2- בעייתי","3- בינוני/סביר","4- תקין","5- טוב מאוד"],
        name: "intake_q142",
        value: product.intake_q142,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveQuality, //  ["1-חמור מאוד","2- בעייתי","3- בינוני/סביר","4- תקין","5- טוב מאוד"],
        name: "intake_q143",
        value: product.intake_q143,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveQuality, // ["1-חמור מאוד","2- בעייתי","3- בינוני/סביר","4- תקין","5- טוב מאוד"],
        name: "intake_q144",
        value: product.intake_q144,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveQuality, // ["1-חמור מאוד","2- בעייתי","3- בינוני/סביר","4- תקין","5- טוב מאוד"],
        name: "intake_q145",
        value: product.intake_q145,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveQuality, // ["1-חמור מאוד","2- בעייתי","3- בינוני/סביר","4- תקין","5- טוב מאוד"],
        name: "intake_q146",
        value: product.intake_q146,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveQuality, // ["1-חמור מאוד","2- בעייתי","3- בינוני/סביר","4- תקין","5- טוב מאוד"],
        name: "intake_q147",
        value: product.intake_q147,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        newsection: "התרשמות מהאינטייק",
        type: "radioSelect",
        options:one2fiveLevel, // ["1-נמוך מאוד","2- נמוך","3- בינוני","4- גבוה","5- גבוה מאוד"],
        name: "intake_q151",
        value: product.intake_q151,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveLevel, // ["1-נמוך מאוד","2- נמוך","3- בינוני","4- גבוה","5- גבוה מאוד"],
        name: "intake_q152",
        value: product.intake_q152,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options:one2fiveLevel, // ["1-נמוך מאוד","2- נמוך","3- בינוני","4- גבוה","5- גבוה מאוד"],
        name: "intake_q153",
        value: product.intake_q153,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: one2fiveLevel, //["1-נמוך מאוד","2- נמוך","3- בינוני","4- גבוה","5- גבוה מאוד"],
        name: "intake_q154",
        value: product.intake_q154,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: one2fiveLevel, //["1-נמוך מאוד","2- נמוך","3- בינוני","4- גבוה","5- גבוה מאוד"],
        name: "intake_q155",
        value: product.intake_q155,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: one2fiveLevel, //["1-נמוך מאוד","2- נמוך","3- בינוני","4- גבוה","5- גבוה מאוד"],
        name: "intake_q156",
        value: product.intake_q156,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        type: "radioSelect",
        options: one2fiveLevel, //["1-נמוך מאוד","2- נמוך","3- בינוני","4- גבוה","5- גבוה מאוד"],
        name: "intake_q157",
        value: product.intake_q157,
        id: product.id,
        style: {width: "400px"},
        edit: true
      }
    ] 
     return cellData
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
      var buttonStyle = {marginRight: '0'}
     
      return (
        <div style={{padding: '0 40px 0 0', height:'4000px'}}>
            <h2 >{tableTitle}</h2>
            
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left" 
                      onClick={onSaveTable}>עדכון</button>
                        
            <div className="mynewdivform" style={{width:'1100px'}}>
                <button style={buttonStyle} type="button"  className="btn btn-success pull-left" 
                              onClick={this.toggleDisplay}>שינוי תצוגה</button>
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    // product={product} 
                    cd={this.qData(products) /*cellData*/}
                    detailedDisplay = {this.state.detailedDisplay}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, cd, detailedDisplay} = this.props
      var key = 0;
      return (
        <div className="eachRow">
          {cd.map(cellInfo => {
              if (typeof cellInfo.newsection !== "undefined")
                return(
                <React.Fragment key={key++}>
                  <h3 key={key++} >{cellInfo.newsection}</h3>
                  <EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} 
                            cellData={cellInfo} detailedDisplay={detailedDisplay} />
                </React.Fragment>
                )
              return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} 
                            cellData={cellInfo} detailedDisplay={detailedDisplay} />)
          })}
  
        </div>
      )
  
    }
  
  }

  class EditableFormCell extends React.PureComponent {
    render() {
        const tp = this.props
        const tpc = tp.cellData
        const detailedDisplay = tp.detailedDisplay

        const divStyle = {padding: '0', borderTop: 0, display: 'block',margin: '0 3px 5px 8px'}
        const labelStyle = {display: 'inline-block', width:'40%', marginLeft:'10px', verticalAlign: 'top'}
        const qnumStyle = {marginLeft: '5px', width:'40px', textAlign:'left', display:'inline-block', verticalAlign: 'top'}
        const qnum = tpc.name.replace('intake_','').replace('other','o')
        const divStyleBblock = {padding: 0, verticalAlign: 'top', borderTop: 0, display: 'block', margin: '0 3px 5px 8px' }
        const labelStyleB = {width: '35%', verticalAlign: 'top'}

        if (tpc.type === "radioSelect" || tpc.type === "select"){
          if (detailedDisplay)
            tpc.type = "radioSelect"
          else
            tpc.type = "select"
        }
        if (tpc.type === "radioSelect"){
          return (
            <div className="form-line" style={divStyleBblock}>
              <span style={qnumStyle}>{qnum}</span>
              <label style={labelStyleB} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <RadioSelect value={tpc.value} options={tpc.options} onChange={tp.onProductTableUpdate} id={tpc.id} name={tpc.name} />
            </div>
          )
        }
        if (tpc.type === "select"){
          return(
            <div className={"formLine"} style={divStyle}>
              <span style={qnumStyle}>{qnum}</span>
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <SelectF tp={tp} tpc={tpc} />
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className={"formLine"} style={divStyle}>
              <span style={qnumStyle}>{qnum}</span>
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <TextareaF tp={tp} tpc={tpc} />
              {/* tpc.edit ? 
                <textarea style={tpc.style} name={tpc.name} id={tpc.id} 
                    value={tpc.value} onChange={tp.onProductTableUpdate}
                /> :
                <textarea style={tpc.style} name={tpc.name} id={tpc.id} value={tpc.value} />
              */}
            </div>
          )
        }
        if (tpc.type === "checkbox"){
          return(
            <div className={"formLine"} style={divStyle}>
              <span style={qnumStyle}>{qnum}</span>
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <CustomCheckbox style={{width: '95%'}} name={tpc.name} 
                    id={tpc.id} value={tpc.value}  onChange={tp.onProductTableUpdate}
                    isChecked = {true} /> 
            </div>
          )
        } 
        return (
          <div className={"formLine"} style={divStyle}>
            <span style={qnumStyle}>{qnum}</span>
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>

              <InputF tpc={tpc} tp={tp} />

              {/*tpc.edit  ? 
                <input style={tpc.style} type={tpc.type} name={tpc.name} id={tpc.id} 
                        value={tpc.value} onChange={tp.onProductTableUpdate}
                    /> : 
                    <input style={tpc.style} type={tpc.type} name={tpc.name} id={tpc.id} 
                        value={tpc.value} onChange={tp.onProductTableUpdate} disabled
                        />
              */}
            </div>
        )
  
    }
  }
